import styled from 'styled-components';

import { Button, BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { ActionMenu } from 'ui/actionMenu';
import {
  ActionMenuOption,
  AllowedActionMenuElements,
  MENU_ALIGNMENTS,
  MENU_DIRECTIONS,
} from 'ui/actionMenu/types';
import { ChevronDown } from 'ui/icons';
import { spacing, borderRadius } from 'ui/theme';

import { displayContent } from 'modules/templateEditor/common/content';
import { useSaveTemplate } from 'modules/templateEditor/hooks/useSaveTemplate';
import { useInStudioTakeoverContext } from '../../context/InStudioTakeoverContext';

const ChevronUp = styled(ChevronDown)`
  transform: rotate(180deg);
`;

// expected as button & action menu together
const ComboButton = styled.div`
  display: flex;
  > button:first-child {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-right: ${spacing.single} solid rgb(0 0 0 / 0.08);
  }
  > *:last-child > button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
`;

export const StyledIconButton = styled(IconButton)`
  margin-right: -${spacing.single};
  border-radius: 0 ${borderRadius.md} ${borderRadius.md} 0;
`;

export const SaveButtonCombo = () => {
  const { setIsSavingDesignChanges } = useInStudioTakeoverContext();
  const { saveTemplate } = useSaveTemplate();

  const setViewOptions: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: displayContent.btnSaveDesignAndExit,
      id: 'btn-save-design-and-exit',
      onClick: () => {
        setIsSavingDesignChanges(true);
        saveTemplate();
      },
    },
  ];

  return (
    <ComboButton>
      <Button
        data-test={'btn-save-design'}
        onClick={() => saveTemplate()}
        size={BUTTON_SIZES.LARGE}
        variant={BUTTON_VARIANTS.PRIMARY}
      >
        <span>{displayContent.btnSaveDesign}</span>
      </Button>
      <ActionMenu
        align={MENU_ALIGNMENTS.RIGHT}
        direction={MENU_DIRECTIONS.TOP}
        options={setViewOptions}
      >
        <StyledIconButton
          data-test={'btn-save-design-action-menu'}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          <ChevronUp height={24} width={24} />
        </StyledIconButton>
      </ActionMenu>
    </ComboButton>
  );
};

export default SaveButtonCombo;
